import styled from "styled-components";
import { Colors } from '~/config/Colors';

export const Container = styled.div`
  margin-bottom: 0.5rem;

  .titulo-label {
    display: flex;
    justify-content: space-between;
  }

  .Label_title_p {
    margin-bottom: 0.25rem;
  }
  
  .w1 {
    padding-right: 0.15em !important;
    width: 5rem;

    .top-header {
      display: flex;
      justify-content: center !important;
      align-items: center !important;
      width: 100% !important;
      height: 2em !important;
      padding: 0.5em 0em 0.5em 0em !important;
    }
  }

  .icon-button {
    cursor: pointer;
    margin: 0 0.1rem;
  }
`;

export const CardAtividade = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 22rem;
  margin-top: 0.7rem;
  overflow: auto;

  .card-atv-header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 0.5rem;

    .top-header{
      display: flex;
      justify-content: space-between;

      .titulo {
        display: flex;
        flex-direction: row;
        align-items: center;

        .fundo-icon {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          width: 1.40375rem;
          height: 1.40375rem;
          background: ${Colors.Color8};
          border-radius: 0.4375rem;

          .atividade {
            width: 0.95rem;
          }
        }

        .item {
          font-size: 0.75rem;
          color: ${Colors.Color4};
          font-weight: 700;
          margin-left: 0.5rem;
        }
      }
    }

    .titulos-tab{
      display: flex;
      flex-direction: row;
      margin-bottom: 0.25rem;
      background: ${Colors.Color4};
      color: ${Colors.Color9};
      border-radius: 0.5rem;

      span {
        color: ${Colors.Color9};
      }

      .col {
        padding: 0.5em 0em 0.5em 0.5rem;
        display: flex;
        align-items: center;
        height: 2.5rem;

        .titulo {
          font-size: 0.75rem;
          font-weight: 700;
          margin-left: 0.5rem;
        }
      }

      .w1 {
        width: 5rem;
      }

      .w2 {
        width: 10rem;
      }

      .w3 {
        width: 15rem;
      }

      .w4 {
        width: 25rem;
      }

      .w5 {
        width: 33rem;
      }
    }

    .icon-button {
      border: none;
      cursor: pointer;
      background: ${Colors.Color1};
      color: ${Colors.Color7};
      font-size: 1.125rem;
    }
  }

  .card-atv-body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin-top: -0.3rem;

    .top-header {
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: center;
      height: 2rem;
    }

    .padding-left {
      padding: 0;
      padding-left: 0.7em !important;
    }

    .row-top {
      margin-top: 0em !important;
      display: flex;
      flex-direction: row;
    }

    .col {
      padding: 0.5em 0em 0.5em 0rem;
      display: flex;
      align-items: center;
      height: 2.5rem;

      .titulo {
        font-size: 0.75rem;
        font-weight: 700;
        margin-left: 0.5rem;
      }
    }

    .w1 {
      width: 5rem;
    }

    .w2 {
      width: 10rem;
    }

    .w3 {
      width: 15rem;
    }

    .w4 {
      width: 25rem;
    }
      
    .w5 {
      width: 33rem;
    }
      
    .row {
      width: auto;
    
      select, input, TextArea {
        width: 100%;
        margin-top: 0rem;
        border-radius: 0;
        height: 2.5rem;
      }

      TextArea:focus {
        height: 9.5em !important;
      }

      .list-analista {
        display: flex;
        flex-direction: column;

        .item-analista {
          margin-top: 0.5rem;

          .icon-button {
            border: none;
            cursor: pointer;
            background: ${Colors.Color1};
            color: ${Colors.Color7};
            font-size: 1.125rem;
            margin-right: 0.3rem;
          }

          .padding-right {
            padding-right: 1em !important;
          }

          .col {
            display: flex;
            align-items: center;
            flex-direction: row;
            padding: 0rem;

            p {
              font-size: 0.75rem;
              color: ${Colors.Color7};
              font-weight: 500;
              margin-left: 0.5rem;
              width: 11rem;
            }
          }
        }
      }
    }

    .geraProjeto {
    
      input, TextArea {
        width: 100%;
        margin-top: 0em !important;
      }
    }
  }

  .sub-atividade {
    background: ${Colors.Color2};
    border-radius: 0.6rem;
    padding-bottom: 0.6rem;
    padding-top: 0.6rem;
    margin-bottom: 1rem;
    margin-left: 1rem;
    margin-top: 0.35rem;

    .add-header {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      height: 100%;
      
      button {
        width: 1.8rem !important;
        padding: 0 !important;
        height: 1.8rem !important;
        font-size: 1.5rem !important;
        line-height: 1rem !important;
        color: #fff !important;
      }
    }

    .top-header {
      button {
        width: 1.8rem !important;
        padding: 0 !important;
        height: 1.8rem !important;
        font-size: 1.5rem !important;
        line-height: 1rem !important;
        color: #fff !important;
      }
    }

    .titulos-tab {
      display: flex;
      flex-direction: row;
      margin-bottom: 0.25rem;
      background: ${Colors.Color23};
      color: ${Colors.Color9};
      border-radius: 0.5rem;

      span {
        color: ${Colors.Color9};
      }
    }
      
    .col {
      padding: 0.5em 0em 0.5em 0rem;
      display: flex;
      align-items: center;
      height: 2.5rem;

      .titulo {
        font-size: 0.75rem;
        font-weight: 700;
        margin-left: 0.5rem;
      }
    }

    .w1 {
      width: 5rem;
    }

    .w2 {
      width: 10rem;
    }

    .w3 {
      width: 15rem;
    }

    .w4 {
      width: 25rem;
    }

    .w5 {
      width: 27rem;
    }
  }
`;